import NavBar from "./NavBar.js"; 
import Accordion from "./Utils/Accordion.js"; 
import SocialShare from "./Utils/SocialShare.js"; 
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ReactPlayer from "react-player"; 
import axios from "axios"; 
import Carousel from 'react-bootstrap/Carousel';
import { formatDatemmmddyyy } from "../utils/utils.js";
import { Helmet } from "react-helmet";
import MetaTags from "react-meta-tags";

function Product(props) {

   
    const [productDetails, setProduct] = useState([{}]);    
    const [imageList, setimageList] = useState([]);    
    const [error, setError] = useState("");
    const [seeMore, setseeMore] = useState(true);
    const [description, setDescription] = useState('');
    const [hiddescription, setHidDescription] = useState('');
   // const product = { "code": 200, "status": "Success!", "message": { "cuisine": { "meal_type": [{ "id": 10, "type": "Lunch" }, { "id": 12, "type": "Dinner" }], "cuisine": [{ "id": 3, "type": "Indian" }], "dietery": [], "sizes": [{ "id": 3, "size": "Medium" }, { "id": 4, "size": "Large" }], "ingredients": "boneless & skinless chicken, yogurt, ginger, garlic, garam masala, turmeric, ground cumin, kashmiri chilli, ground corriander, ground red chilli power, cream, salt, cilantro, vegetable oil, butter, onion, tomato", "allergens": [{ "id": 5, "allergen": "Milk" }], "nutrients": [{ "total_calories": "800cal", "total_fat": "50g", "saturated_fat": "20g", "trans_fat": "15g", "cholesterol": "300mg", "sodium": "750mg", "total_carbohydrate": "20g", "dietary_fiber": "5g", "sugars": "150g", "protein": null }] }, "chef": { "name": "Nalan Doe", "age": 45, "country": "India", "bio": "Experienced and talented Indian chef skilled in the preparation and serving of Asian foods. Adheres to standards in cooking. Capable of giving every meal an exciting and unique spin that always impresses.", "images": "https://global-uploads.webflow.com/61154a627733993096a9a3af/618ae06883ad82a13f292916_dl.png", "video": "https://www.youtube.com/watch?v=E9bSLVgw0qI" }, "customer": { "name": "Madras Chettinad", "active": true, "subscription_end_date": "2023-03-01T00:00:00.000Z", "address_1": "123 Main Street", "city": "Alpharretta", "state": "GA", "country": "USA", "logo": "http://1.bp.blogspot.com/-52DP34Lcn94/Tj9HXb1ay7I/AAAAAAAAA-A/tB1zRIRftK8/s320/Restaurant-18894-Madras-Chettinaad-68324.jpg" }, "name": "Chicken Tikka Masala", "title1": "chicken tikka masala", "title2": "chicken thighs or breasts", "desc1": "The BEST part about this recipe and just like our Butter Chicken � you may already have these ingredients in your kitchen. If not, they are so easy to find in any grocery store, you won�t need to go searching high and low to find them! Authentic Chicken Tikka Masala is usually made with yogurt marinated chicken, skewered and chargrilled for incredible bbq flavours. For the sake of making this recipe much easier for us to make at home, we are using a skillet or pot to cook it all in, while still keeping those amazing flavours.", "desc2": "We are still coating and marinating our chicken with an aromatic spiced Tikka yogurt, using chicken thighs instead of breasts for juicy and succulent results. Using thighs also cuts down on marinating time, needing only a minimum of 10 minutes to soak all of those flavours in!", "images": "https://cafedelites.com/wp-content/uploads/2018/04/Chicken-Tikka-Masala-IMAGE-22.jpg,https://cafedelites.com/wp-content/uploads/2018/04/Best-Chicken-Tikka-Masala-IMAGE-2.jpg,https://media.istockphoto.com/photos/chicken-tikka-indian-food-picture-id1150376652,https://media.istockphoto.com/photos/kebab-grilled-chicken-meat-and-vegetables-picture-id1068906264,https://media.istockphoto.com/photos/roasted-chicken-wings-served-on-a-white-plate-with-peppers-onions-picture-id1178859373", "video": "https://www.youtube.com/watch?v=BOKdsepCrbc", "date_created": "2022-03-20T00:00:00.000Z", "date_expired": "2023-03-01T00:00:00.000Z", "price": 12.99, "discount_price": 9.99, "discount_percentage": 0, "sale": false, "sale_reason": null, "date_sale_expired": null }, "errors": [] };
    const [shareUrl, setshareUrl] = useState("https://dev.plesscloud.com/");
    const [backgroungImage, setbackgroungImage] = useState('');
    

    useEffect(() => {        
            fetchProducts();             
    },[])

   
 
    const fetchProducts = () => {

        if (props.details)
        {

            const wordLimit = 50;

            setProduct(props.details);


            const list = [];
            const image = props.details["images"].split(',');
            const video = props.details["video"];

            // truncate the description
            const desc = (props.details["desc1"] + props.details["desc2"]);
            const descValue = desc.split(' ');

                if(desc.split(' ').length < 60)
            {
                setseeMore(false);
                setDescription(desc);
            } else {
            setseeMore(true);
            setDescription(descValue.slice(0, 60).join(' '));
            setHidDescription(descValue.slice(60, desc.split(' ').length).join(' '));
        }



            for (let i = 0; i < image.length; i++) {
                list.push({ "mode": "img", "src": image[i], "display": image[i] });


            }
            if (video && video !="")
                list.push({ "mode": "video", "src": "../../../img/videoplay.jpg", "display": video });

             

            if (list && list.length > 0) {
                const countlist = [];
                const rem = ((list.length % 3) != 0) ? 1 : 0
                const count = ((list.length - (list.length % 3)) / 3) + rem;
                for (let i = 0; i < count; i++) {
                    const endIndex = (((i + 1) * 3) > list.length) ? list.length : ((i + 1) * 3);
                    const slicedItem = list.slice(i * 3, endIndex);
                    if (slicedItem.length < 3) {
                        if (list.length > 3 && slicedItem.length == 1) {
                            
                            slicedItem.push(list[0]);
                            slicedItem.push(list[1]);
                            console.log(slicedItem);
                        }
                        if (list.length > 3 && slicedItem.length == 2) {
                            slicedItem.push(list[0]);
                        }
                    }
                    countlist.push({ "index": i, "item": slicedItem });
                }
                setimageList(countlist);
            }

            setbackgroungImage(list[0]["display"]);
            setSelectedImage(list[0]["display"]);
        }
    }
   
    const [selectedImage, setSelectedImage] = useState('');
    const [selectedVideo, setselectedVideo] = useState('');
    const [toggleCtrl, settoggleCtrl] = useState(true);


    const onImageClick = (src, code) => {
        (code != 'img') ? settoggleCtrl(false) : settoggleCtrl(true);

        (code != 'img') ? setselectedVideo(src) :  setSelectedImage(src); 
    }
    const bgStyle = { backgroundImage: "url('" + backgroungImage+"')" };
    return (
        <><helmet></helmet>
             
            <MetaTags>
                <title> {(productDetails && props.details && props.details["customer"]["name"]) ? props.details["customer"]["name"]+'- Menu Item -' + props.details["name"] : 'Product-Menu Item'}</title>

                </MetaTags> 
           
            {(productDetails   && error == "") ? <>
                <section className="bg-darkGray py-4  make-sticky sticky-top">
                    {(props.details["customer"]) ?<>
                        <div className="container py-1">
                            <div className="row   gy-1  align-items-center centeralign">
                                <div className="col-md-4 col-lg-2 col-sm-12  ">
                                    <img className="d-none d-md-inline-block w-100" style={{ height: 100 }} src={props.details["customer"]["logo"]} alt="Customer logo" /><img className="d-inline-block d-md-none" style={{ height: 80 }} src={props.details["customer"]["logo"]} alt="Customer logo" />
                                </div>
                                <div className="col-md-8 col-lg-9 col-sm-12 white-text ">
                                    <h2 className="mt-4 mb-1">{props.details["customer"]["name"]}</h2>
                                    <h4 className="mb-3">{props.details["customer"]["city"]} , {props.details["customer"]["state"]} , { props.details["customer"]["country"] }</h4>
                                </div>
                               
                            </div>
                        </div></>
                        :''}
                </section>
                
                 <div className="w-100 h-100">
                    <section className="py-5 imageBackground " style={bgStyle}>
                        
                    <div className="container px-4 py-4 childBackground" >
                        <div className="row g-3 px-1 py-1 border bg-light">
                            <div className="col-lg-7">
                                {(selectedImage != "") ?
                                    <div className="row mb-2">
                                     <div className="col-12 d-flex justify-content-center pt-2 pb-1 ">
                                        {(toggleCtrl) ? <div className="pro-image"><img src={selectedImage} className="d-block  w-100 h-100 img-thumbnail" alt="..." style={{ objectFit: "cover" }} /> </div> :

                                                <div className="pro-image"><ReactPlayer controls={true} url={selectedVideo} width="100%" height="100%" /></div>}


                                     </div>
                                     <div className="col-12 pt-1"> 
                                        
                                        <Carousel>

                                            {imageList.map((item, index) => (
                                            <Carousel.Item interval={3000}>
                                                
                                                <div className="row gx-2 mt-4 ">
                                                   
                                                        {item["item"].map((image, index) => (<>
                                                            <div className="product col-4 col-sm-4 col-lg-4 pb-3" key={index}>
                                                                <div className="product-image"><img src={image["src"]}  onClick={() => onImageClick(image["display"], image["mode"])} className="d-block w-100 imageButton img-thumbnail img-fluid thumbnail" alt="..." /></div>
                                                            </div>
                                                        </>))}
                                                    
                                                </div>                                                
                                            </Carousel.Item>
                                             
                                            ))}
                                        </Carousel>

                                    </div>
                                        <div className="w-100 col-md-6" >
                                                <SocialShare url={shareUrl} productName={(productDetails && props.details && props.details["customer"]["name"]) ? props.details["customer"]["name"] + '- Menu Item -' + props.details["name"] : 'Product-Menu Item'} productDesc={description} productImage={selectedImage}  title={(productDetails && props.details && props.details["customer"]["name"]) ? props.details["customer"]["name"] + '- Menu Item -' + props.details["name"] : 'Product-Menu Item'}/>
                                             
                                            </div>

                                 
                                    </div> : ''}
                            </div>

                            <div className="col-lg-5">


                                <div className="row gy-5  align-items-stretch">
                                    <div className="col-lg-12 d-flex flex-column justify-content-between">
                                        <div className="p-4 p-lg-5 card mb-5 mt-2 desc-box  ">
                                            <form action="#" >
                                                {(props.details["sale"] && new Date(props.details["date_sale_expired"]) >= new Date()) ?
                                                    <ul className="list-unstyled p-0 ribbon-holder mb-0">
                                                        <li className="mb-1">
                                                            <div className="ribbon sale ribbon-primary"> {(props.details["sale_reason"] == '') ? "Sale" : props.details["sale_reason"] }</div>
                                                        </li>
                                                    </ul>:''}

                                                <h2 className="text-center mt-4 mb-1">{(productDetails && props.details) ? props.details["name"] : ''}</h2>
                                                <h4 className="text-center text-muted  mb-3">{(productDetails && props.details) ? props.details["title1"] + ((props.details["title2"] && props.details["title2"]!='') ?' - ' + props.details["title2"] :'') : ""}</h4>
                                                <p className="h2 text-muted mb-1 text-center fw-normal">{(productDetails && props.details && !props.details["discount_price"]) ? <span className="blue-text"> $ {parseFloat(props.details["price"]).toFixed(2)}</span> : <> <del>${parseFloat(props.details["price"]).toFixed(2)}</del> <span className="blue-text">${parseFloat(props.details["discount_price"]).toFixed(2)}</span></>}</p>
                                                <p className="text-center"> {(props.details["discount_percentage"] && props.details["discount_percentage"] > 0) ?
                                                    <>  
                                                        <span className="badge fw-light text-uppercase bg-info">Discount  {parseFloat(props.details["discount_percentage"]).toFixed(2) + '%'}</span><br /> 
                                                       
                                                    </> : ''}
                                                    <span className="h6 text-muted me-3" > {(props.details["sale"] && new Date(props.details["date_sale_expired"]) >= new Date()) ? "Sale Expiry : " + formatDatemmmddyyy(props.details["date_sale_expired"]) : ''}</span></p>
                                                <div >
                                                    <h4 className="h5 lined text-uppercase mb-2">Description</h4>


                                                    <div className=" box-height overflow-auto" ><p className="text-sm mb-0 "> {description} {(seeMore) ? <span className="blue-text imageButton" onClick={() => setseeMore(false)} ><h5><strong>Read more...</strong></h5></span> : <> <span>{hiddescription}</span> < span className="blue-text imageButton" onClick={() => setseeMore(true)} ><h5>{(hiddescription != '') ? <strong> Read less...</strong> : ''}</h5></span> </>}  </p> </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 p-0">
                                <div className="accordion px-2 m-0" id="accordionPanelsStayOpenExample">
                                    {(productDetails && props.details && props.details["cuisine"]) ?

                                        <>  <div className="accordion-item mb-2">
                                            <h2 className="accordion-header" id="panelsStayOpen-headingThree">
                                                <span className="accordianButton text-uppercase fw-bold bg-light border-bottom " >
                                                    <span className="blue-text"> Menu</span></span>
                                            </h2>
                                            <div id="panelsStayOpen-collapseFour" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingFour">
                                                <div className="accordion-body">

                                                    <form className="form-horizontal">

                                                        <div className="row ">
                                                            <label className="col-sm-6 form-label" ><strong>Menu Type  :</strong>  {props.details["cuisine"]["meal_type"].map((item, index) => (<> {item["type"]}  {((props.details["cuisine"]["meal_type"].length - 1) == index) ? '' : ","} </>))}  </label>

                                                            <label className="col-sm-6 form-label" ><strong>Cuisine  :</strong>{props.details["cuisine"]["cuisine"].map((item, index) => (<> {item["type"]}  {((props.details["cuisine"]["cuisine"].length - 1) == index) ? '' : ","} </>))}  </label>


                                                        </div>

                                                        <div className="row">
                                                            <label className="col-sm-6 form-label" ><strong>Available sizes  :</strong> {props.details["cuisine"]["sizes"].map((item, index) => (<> {item["size"]}  {((props.details["cuisine"]["sizes"].length - 1) == index) ? '' : ","} </>))}   </label>

                                                            <label className="col-sm-6 form-label" ><strong>Ingredients  :</strong>  {props.details["cuisine"]["ingredients"]}</label>

                                                        </div>

                                                    </form>
                                                </div></div></div>
                                            {(props.details["cuisine"]["nutrients"] && props.details["cuisine"]["nutrients"].length !=0) ?
                                                <> <div className="accordion-item mb-2">
                                                    <h2 className="accordion-header" id="panelsStayOpen-headingFive">
                                                        <span className="accordianButton  border-bottom" ><span className="blue-text text-uppercase fw-bold bg-light">  NUTRIENTS  </span> <h6 className="mt-2">&nbsp; (per Medium Size)</h6></span>
                                                    </h2>
                                                    <div id="panelsStayOpen-collapseFive" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingFive">
                                                        <div className="accordion-body">
                                                            <form className="form-horizontal">


                                                                <div className="row ">
                                                                    {props.details["cuisine"]["nutrients"].map((data, index) => (<> 
                                                                        <label key={index} className="col-sm-6 form-label" ><strong>{data["nutrient"]} : </strong>{data["value"]} </label>
                                                                    </>))}

                                                                </div>

                                                            
                                                            </form>

                                                        </div></div></div>
                                                </> : ''}

                                            {(props.details["cuisine"]["dietery"] && props.details["cuisine"]["dietery"].length > 0) ? 
                                                <><Accordion listValue={props.details["cuisine"]["dietery"]} title={"DIETARY"} mapField={"dietery"} /></> : ''}
                                            {(props.details["cuisine"]["allergens"] && props.details["cuisine"]["allergens"].length > 0) ?
                                                <><Accordion listValue={props.details["cuisine"]["allergens"] } title={"ALLERGENS" } mapField={"allergen" }/></>
                                                : ''}
                                        </> : ''
                                    }

                                    {(productDetails && props.details && props.details["chef"]) ?

                                        <div className="accordion-item mb-2">
                                            <h2 className="accordion-header" id="panelsStayOpen-headingSix">
                                                <span className="accordianButton text-uppercase fw-bold bg-light border-bottom" ><span className="blue-text"> Chef </span> </span>
                                            </h2>
                                            <div id="panelsStayOpen-collapseSix" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingSix">
                                                <div className="accordion-body">
                                                    <form className="form-horizontal">

                                                        <div className="d-flex justify-content-left">
                                                        </div>
                                                        <div className="row mb-2">
                                                            <div className="col-sm-2 col-md-4 col-lg-2">
                                                                <div className="row text-center justify-content-center">
                                                                    {(props.details["chef"]["images"]) ? <img src={props.details["chef"]["images"]} className="col-sm-9  rounded-circle" alt="..." /> : ''}
                                                                    <label className="col-sm-12 form-label p-0 m-0 pt-1" ><h4><strong> {props.details["chef"]["name"]} ({props.details["chef"]["country"]})</strong></h4><h6>Age: {props.details["chef"]["age"]} yrs</h6> <h6 className="form-label " ><strong>  </strong> </h6></label>

                                                                </div> </div>
                                                            {(props.details["chef"]["video"] && props.details["chef"]["video"] !="") ?
                                                                <>
                                                                    <div className="col-sm-4 col-md-8  col-lg-4">
                                                                        <div className="row mb-2">

                                                                            <label className="col-sm-12 col-md-12 col-lg-12 form-label" ><p>
                                                                                <h4 className="h5 lined text-uppercase mb-2">Biography</h4>
                                                                                {props.details["chef"]["bio"]}
                                                                            </p></label>
                                                                        </div>

                                                                    </div>
                                                                    <div className="col-sm-6 col-md-12 col-lg-6 justify-content-right">
                                                                        <div className="row  justify-content-right h-100">
                                                                            <div className="col-md-4 col-sm-12 col-lg-12 justify-content-right"></div>
                                                                            <div className="col-md-8 col-sm-12 col-lg-12 justify-content-right  ">
                                                                                <div className="reactplayer"><ReactPlayer controls={true}    url={props.details["chef"]["video"]} width="100%" height="100%" /></div></div>
                                                                        </div> </div>
                                                                </> :
                                                                <div className="col-sm-10 col-md-8  col-lg-10">
                                                                    <div className="row mb-2">

                                                                        <label className="col-sm-12 col-md-12 col-lg-12 form-label" ><p>
                                                                            <h4 className="h5 lined text-uppercase mb-2">Biography </h4>
                                                                            {props.details["chef"]["bio"]}
                                                                        </p></label>
                                                                    </div>

                                                                </div>}


                                                        </div>


                                                    </form>
                                                </div></div></div>
                                        : ''}

                                </div></div>
                        </div>

                    </div>


                   
                </section>
</div>
           </>:''}
          
       </>
 
  );
}

export default Product;